import { SupportEmailLink } from "components/app/support-email-link";
import { ContentFull, ContentHeader } from "components/layout";
import { Mailchimp } from "components/mailchimp";
import { InlineBanner } from "components/ui/inline-banner";
import { PremiumCallout } from "components/ui/premium-callout";
import React from "react";
import { useProductName } from "store/selectors/branding";
import { useFeature } from "store/selectors/hooks";

interface ManageIntegrationsMailchimpProps {
    match?: {
        path?: string;
        params?: {
            audienceId?: string;
            subtab?: string;
            audienceTab?: string;
        };
    };
}

export const ManageIntegrationsMailchimp: React.FC<
    ManageIntegrationsMailchimpProps
> = props => {
    const isFeatureEnabled = useFeature("mailchimp");
    const productName = useProductName();

    if (isFeatureEnabled) {
        return <Mailchimp match={props.match} />;
    }

    return (
        <ContentFull>
            <ContentHeader>Mailchimp</ContentHeader>
            <PremiumCallout>
                <InlineBanner type="info">
                    Mailchimp is only available on request to {productName} Premium
                    customers. <br />
                    Please{" "}
                    <SupportEmailLink
                        label="contact support"
                        subject="Mailchimp Integration"
                    />{" "}
                    to request an upgrade.
                </InlineBanner>
            </PremiumCallout>
        </ContentFull>
    );
};
